import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  // Fetch / upsert profile for current user
  const loadProfile = async (u) => {
  if (!u) { setProfile(null); return; }
  const { error: upErr } = await supabase.from('profiles').upsert({
    id: u.id, email: u.email, display_name: u.user_metadata?.full_name || null,
  }, { onConflict: 'id' });
  if (upErr) { console.error('profiles upsert failed', upErr); return; }

  const { data, error: selErr } = await supabase
    .from('profiles').select('*').eq('id', u.id).single();
  if (selErr) { console.error('profiles select failed', selErr); return; }
  setProfile(data || null);
};

  useEffect(() => {
    (async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setUser(session?.user ?? null);
      await loadProfile(session?.user ?? null);
      setAuthLoading(false);
    })();

    const { data: sub } = supabase.auth.onAuthStateChange(async (_event, session) => {
      setUser(session?.user ?? null);
      await loadProfile(session?.user ?? null);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  const signIn = async (email, password) => {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    return { error };
  };

  const signUp = async (email, password, displayName) => {
  const { data, error } = await supabase.auth.signUp({
    email, password,
    options: { data: { full_name: displayName } }
  });
  if (error) return { error };

  // If email confirmation is enabled, there is no session yet.
  // Auto-login to create a session (dev / trusted environments).
  const { error: loginErr } = await supabase.auth.signInWithPassword({ email, password });
  if (loginErr) return { error: loginErr };

  // onAuthStateChange will fire and loadProfile() will upsert the row
  return { error: null };
};


  const signOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <AuthContext.Provider value={{ user, profile, authLoading, signIn, signUp, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
